export interface Plan {
  name: string;
  price: string;
  period: string;
  features: string[];
  cta: string;
  disabled: boolean;
  href: string;
  highlighted: boolean;
  gradient: string;
  isDowngrade: boolean;
  recommended: boolean;
  credits?: number;
  additionalCreditCost?: string;
}

export const getPlans = (currentPlan?: string | null, isCancelled?: boolean): Plan[] => [
  {
    name: 'Free',
    price: '$0',
    period: 'forever',
    features: [
      '3 vectorizations per day',
      'Full-color SVG output',
      'Built-in vector editor',
      'Download SVG files',
      'Personal use',
    ],
    cta: !currentPlan || currentPlan === 'free' ? 'Current Plan' : (isCancelled ? 'Downgrading to Free' : 'Downgrade to Free'),
    disabled: !currentPlan || currentPlan === 'free' || isCancelled === true,
    href: '/',
    highlighted: false,
    gradient: 'bg-gray-700',
    isDowngrade: !!currentPlan && currentPlan !== 'free',
    recommended: false,
  },
  {
    name: 'Pro',
    price: '$9.99',
    period: 'per month',
    credits: 1000,
    additionalCreditCost: '2¢',
    features: [
      '1,000 vectorizations per month',
      'Full-color SVG output',
      'Built-in vector editor',
      'REST API & MCP access',
      'Commercial use allowed',
      'Priority processing',
      'Premium support',
      'Cancel any time',
    ],
    cta:
      currentPlan === 'pro'
        ? isCancelled
          ? 'Resume Subscription'
          : 'Current Plan'
        : 'Upgrade to Pro',
    disabled: currentPlan === 'pro' && !isCancelled,
    href: '/api/purchase/pro',
    highlighted: !currentPlan || currentPlan === 'free',
    gradient: 'from-[#00FFBF] to-[#2E95FF]',
    isDowngrade: false,
    recommended: !currentPlan || currentPlan === 'free',
  },
  {
    name: 'API',
    price: 'Included',
    period: 'with Pro',
    features: [
      'REST API access',
      'Batch processing',
      'MCP server for AI agents',
      'All Pro features included',
      'API key management',
    ],
    cta: !currentPlan || currentPlan === 'free' ? 'Upgrade to Pro' : 'View API Docs',
    disabled: false,
    href: !currentPlan || currentPlan === 'free' ? '/api/purchase/pro' : '/account',
    highlighted: false,
    gradient: 'from-[#FF0090] to-[#7200DD]',
    isDowngrade: false,
    recommended: false,
  },
  {
    name: 'Enterprise',
    price: 'Custom',
    period: '',
    features: [
      'Volume pricing',
      'Dedicated infrastructure',
      'Custom integrations',
      'SLA & uptime guarantees',
      'Dedicated account manager',
    ],
    cta: 'Contact Us',
    disabled: false,
    href: 'mailto:contact@svg.new',
    highlighted: false,
    gradient: 'from-[#FCAF28] to-[#FF3C00]',
    isDowngrade: false,
    recommended: false,
  },
];

export const PRICE_PER_CREDIT = 0.02; // 2 cents per credit
